import React from 'react';
import { useParams } from 'react-router-dom';
import { UrlParams } from '../PackUsage';
import { useGetMetricGroupsDropdownQuery } from '@api/initiatives';
import { RequestScope } from '../../../../../../actions/api';
import { CustomSelectOption, SelectPacks } from '@features/select-packs';
import { PACK, SURVEY } from '@constants/terminology';
import { RequestScopeExtended } from '@utils/requestScope';

interface FilterSurveyPackProps {
  selectedScopes?: string[];
  handleSurveyPackFilter: (scopes: RequestScope[]) => void;
  extraOptions?: RequestScopeExtended[];
}

export const FilterSurveyPacks = (props: FilterSurveyPackProps) => {
  const { selectedScopes, handleSurveyPackFilter, extraOptions } = props;
  const { group } = useParams<UrlParams>();
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const { data: metricGroups } = useGetMetricGroupsDropdownQuery(portfolioId);
  const groupOptions = metricGroups?.reduce((acc, cur) => {
    acc[cur._id] = { name: cur.groupName, src: cur.groupData?.icon };
    return acc;
  }, {} as CustomSelectOption);

  return (
    <SelectPacks
      placeholder={`${SURVEY.CAPITALIZED_ADJECTIVE} ${PACK.SINGULAR}`}
      selectedScopes={selectedScopes}
      groupOptions={groupOptions}
      handleChangePacks={handleSurveyPackFilter}
      isDisabled={!!group}
      extraOptions={extraOptions}
    />
  );
};
